<template>
  <!--
    「요금·결제」 상세의 사유만 받는 창 한 곳 — 자동 결제 멈추기 · 지정 풀기 · 신청 취소(설계안 §21.4 · §20.5 · §25.6). 매장 · 안내 · (있으면)
    빨간 주의 한 줄 · 사유 칸만 그린다. 보내기·거절의 갈래는 동작마다 다르므로 부모가 갖는다 — 이 창은 [실행] 때 적은 사유를 `submit` 으로
    올리고, 부모가 준 고칠 말(`problem`)·진행(`busy`)을 그린다. 열 때마다 사유를 비운다.
  -->
  <el-dialog
    :title="$t(title)"
    :visible="visible"
    width="440px"
    append-to-body
    :data-testid="`${testid}-dialog`"
    :close-on-click-modal="false"
    @update:visible="$emit('update:visible', $event)"
    @open="reason = ''">
    <p class="subscription-reason__store">{{ storeLabel }}</p>
    <p class="subscription-reason__intro" :data-testid="`${testid}-intro`">{{ $t(intro) }}</p>
    <p v-if="notice" class="subscription-reason__notice" :data-testid="`${testid}-notice`">{{ $t(notice) }}</p>
    <el-form label-position="top" @submit.native.prevent>
      <el-form-item :label="$t(reasonLabel)" :error="problem">
        <el-input
          v-model="reason"
          type="textarea"
          :rows="3"
          :data-testid="`${testid}-reason`"
          :placeholder="$t(text.reasonPlaceholder)"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="$emit('update:visible', false)">{{ $t(text.close) }}</el-button>
      <el-button
        size="small"
        :type="submitType"
        :data-testid="`${testid}-submit`"
        :loading="busy"
        @click="$emit('submit', reason)"
        >{{ $t(submitLabel) }}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { SUBSCRIPTION_TEXT } from '@/utils/subscriptionAdmin'

export default {
  name: 'SubscriptionReasonDialog',

  props: {
    visible: { type: Boolean, default: false },
    /** 시험 id 머리 — `{testid}-dialog`·`-intro`·`-notice`·`-reason`·`-submit` */
    testid: { type: String, required: true },
    title: { type: String, required: true },
    storeLabel: { type: String, default: '' },
    /** 하는 일 한 줄 */
    intro: { type: String, default: '' },
    /** 빨간 주의 한 줄 — 없으면 그리지 않는다 */
    notice: { type: String, default: '' },
    reasonLabel: { type: String, required: true },
    submitLabel: { type: String, required: true },
    /** 실행 단추 색 — 되돌리기 어려운 동작은 `danger` */
    submitType: { type: String, default: 'primary' },
    /** 칸 아래 고칠 말(사유 없음·서버 문장) — 부모가 정한다 */
    problem: { type: String, default: '' },
    busy: { type: Boolean, default: false },
  },

  data: function () {
    return { text: SUBSCRIPTION_TEXT, reason: '' }
  },
}
</script>

<style scoped>
.subscription-reason__store {
  margin: 0 0 8px;
  color: var(--color-text-regular);
}

.subscription-reason__intro {
  margin: 0 0 8px;
  color: var(--color-text-regular);
  word-break: keep-all;
}

.subscription-reason__notice {
  margin: 0 0 12px;
  color: var(--color-danger);
  word-break: keep-all;
}
</style>
